<!--
 * @Description: 
 * @Autor: yd
 * @Date: 2020-07-13 09:23:25
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-01-18 10:07:34
-->
<template>
  <div>
    <mrc_ess_table
      v-if="$route.name == 'codeLogic'"
      :headers="headers"
      :hideAddBtn="!hasBtn('add-logic-configuration')"
      pageName="addCodeLogic"
      :paginationOptions="options"
      @turnPage="getlist"
      :slotKey="['is_used', 'nameAndRemark']"
      :isLoading="loading"
      :items="desserts"
    >
      <template v-slot:search>
        <v-row
          class="d-flex justify-end"
          style="background: white;
          margin: 0;
          border-top-right-radius: 8px;
          border-top-left-radius: 8px;padding: 0 16px"
        >
          <mrc_ess_advanceFilterAndSearchInput
            class="mt-4"
            v-model="systemSeniorQueryString"
            @success="getlist({ cpage: 1 })"
            :systemFieldMeta="systemFieldMeta"
          ></mrc_ess_advanceFilterAndSearchInput>
        </v-row>
      </template>
      <template #item.nameAndRemark="{item}">
        <div>
          <div>{{ INT(item.change_process_name) }}</div>
          <div class="text--secondary overflow" style="width:500px;">
            {{ INT(item.remark) }}
          </div>
        </div>
      </template>

      <!-- 状态 -->
      <template #item.is_used="{item}">
        <mrc_ess_viewbtn
          :is_used="item.is_used_save_value"
          :label="item.is_used"
        ></mrc_ess_viewbtn>
      </template>
      <!-- 操作 -->
      <template v-slot:item.actions="{ item }">
        <menu-list :list="menulist" @handleClick="handleClick($event, item)">
          <template v-slot:showAction>
            <v-icon
              v-btnAuth="[
                'view-logic-configuration',
                'edit-logic-configuration',
                'delete-logic-configuration',
              ]"
              >mdi-dots-vertical</v-icon
            >
          </template>
        </menu-list>
      </template>
    </mrc_ess_table>
    <router-view v-else></router-view>
  </div>
</template>

<script>
import {
  getCodeLogicList,
  addCodeLogic,
  detailCodeLogic,
  updateCodeLogic,
  deleteCodeLogic,
} from "@/service/api/codeLogic.js"
export default {
  components: {},
  props: {},
  data() {
    return {
      systemFieldMeta: [],
      field_alias_name: null,
      table_alias_name: null,
      systemSeniorQueryString: [],
      disabled: true,
      list: {},
      options: {
        pagesize: this.$store.state.pageSize, //条数
        cpage: this.$store.state.cpage, //页数
        totalcount: null, //总条数
        totalpage: null, //总页数
      },
      loading: false,

      desserts: [],
    }
  },
  beforeDestroy() {},
  computed: {
    headers() {
      return [
        {
          text: this.$t("label_name_and_notes"),
          align: "start",
          value: "nameAndRemark",
          sortable: false,
        },
        {
          text: this.$t("label_Change_the_table"),
          value: "change_table_uuid",
          sortable: false,
          align: "start",
        },
        {
          text: this.$t("label_state"),
          value: "is_used",
          sortable: false,
          align: "start",
        },
        {
          text: "",
          value: "actions",
          sortable: false,
          align: "end",
        },
      ]
    },
    menulist() {
      return [
        {
          name: this.$t("label_View"),
          show: this.hasBtn("view-logic-configuration"),
          type: "view",
        },
        {
          name: this.$t("label_Edit"),
          show: this.hasBtn("edit-logic-configuration"),
          type: "edit",
        },
        {
          name: this.$t("label_delete"),
          show: this.hasBtn("delete-logic-configuration"),
          type: "del",
        },
      ]
    },
  },
  beforeCreate() {
    this.$store.commit("setCpage", 1)
  },
  async created() {
    await this.getBtnPermissionList()
  },
  watch: {
    $route(v) {
      if (v.name == "codeLogic") {
        this.getlist()
      }
    },
  },
  async mounted() {
    await this.getlist()
  },

  methods: {
    async getlist(obj) {
      this.loading = true
      if (
        this.desserts &&
        this.desserts.length == 1 &&
        this.options.cpage != 1 &&
        this.$route.params.type == "del"
      )
        this.options.cpage--
      if (obj) {
        const { cpage, pagesize } = obj
        this.options = { ...this.options, ...obj }
      }
      const res = await getCodeLogicList({
        cpage: this.options.cpage,
        pagesize: this.options.pagesize,
        systemSeniorQueryString: this.systemSeniorQueryString,
        field_alias_name: this.field_alias_name,
        table_alias_name: this.table_alias_name,
      })
      if (res.code == 200) {
        this.desserts = res.data
        this.options.totalcount = res.totalcount
        this.options.totalpage = res.totalpage
        this.systemFieldMeta = res.systemFieldMeta
        this.field_alias_name = res.field_alias_name
        this.table_alias_name = res.table_alias_name
      }
      this.loading = false
    },
    handleClick({ index, item }, obj) {
      switch (item.type) {
        case "view":
          this.$store.commit("set_subPage_name", obj.change_process_name)
          this.$store.commit("set_iconstatus", true) //行内进图标显示
          this.$store.commit("set_uuid", obj.uuid) //
          this.$router.push({
            name: "detailCodeLogic",
          })
          break
        case "edit":
          this.$store.commit("set_subPage_name", obj.change_process_name)
          this.$store.commit("set_iconstatus", false) //行内进图标显示
          this.$store.commit("set_uuid", obj.uuid) //
          this.$router.push({
            name: "detailCodeLogic",
          })
          break
        case "del":
          this.$myConfirm({
            content: this.$t("message_Confirm_the_deletion"),
          }).then((res) => {
            deleteCodeLogic({ uuid: obj.uuid }).then((res) => {
              if (res.code == 200) {
                this.$Message({
                  text: this.$t("message_The_deletion_was_successful"),
                })
                this.getlist()
              }
              // else {
              //   this.$Message({
              //     text: this.$t('删除失败'),
              //     color: rgba(0, 0, 0, 0.38),
              //   })
              // }
            })
          })
          break
      }
    },
    // godetail (item) {
    //   this.$store.commit('set_iconstatus', true)  //行内进图标显示
    //   // this.$store.commit('set_subPage_name', item.param_name)
    //   this.$store.commit('set_uuid', item.uuid)  //
    //   this.$router.push({
    //     name: 'detailCodeLogic'
    //   })
    // },
    // addemailtemplate () {
    //   this.$store.commit('set_subPage_name', '')
    //   this.$store.commit('set_uuid', '')
    //   this.$store.commit('set_iconstatus', '')  //行内进图标显示
    //   this.$router.push({
    //     name: 'addCodeLogic'
    //   })
    // }
  },
}
</script>

<style scoped>
.overflow {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.cardtitle {
  position: relative;
}
.emailbtn {
  position: absolute;
  right: 70px;
  top: -50px;
}
</style>
